import React, { useState } from "react"

import { Translate } from "../../Components/Translator"
import { EmbeddedZohoGetSettingAutoCreateCall, EmbeddedZohoSetSettingAutoCreateCall, EmbeddedZohoGetSettingAutoOpenMatch, 
    EmbeddedZohoSetSettingAutoOpenMatch, EmbeddedZohoGetSettingAutoCreateMatch, EmbeddedZohoSetSettingAutoCreateMatch,
    EmbeddedZohoGetSettingDefaultInboundCallSubject,EmbeddedZohoSetSettingDefaultInboundCallSubject,
    EmbeddedZohoGetSettingDefaultOutboundCallSubject,EmbeddedZohoSetSettingDefaultOutboundCallSubject } from "./EmbeddedZohoSupport.jsx"

const EmbeddedZohoSettings = (props) => {

    const [mRepainter, SetRepainter] = useState(0)

    const SetSettingAutoCreateCall = (value) => {
        EmbeddedZohoSetSettingAutoCreateCall(value)
        SetRepainter(mRepainter + 1)
    }

    const SetSettingAutoOpenMatch = (value) => {
        EmbeddedZohoSetSettingAutoOpenMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetSettingAutoCreateMatch = (value) => {
        EmbeddedZohoSetSettingAutoCreateMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultInboundCallSubject = (value) => {
        EmbeddedZohoSetSettingDefaultInboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultOutboundCallSubject = (value) => {
        EmbeddedZohoSetSettingDefaultOutboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const settingautocreatecall = EmbeddedZohoGetSettingAutoCreateCall()
    const settingautoopenmatch = EmbeddedZohoGetSettingAutoOpenMatch()
    const settingautocreatematch = EmbeddedZohoGetSettingAutoCreateMatch()    
    const settingdefaultinboundcallsubject = EmbeddedZohoGetSettingDefaultInboundCallSubject()
    const settingdefaultoutboundcallsubject = EmbeddedZohoGetSettingDefaultOutboundCallSubject()

    return (
        <>
            <tr className="usersettings" height="20"/>
            <tr className="foregroundlightasbackground">
                <td colSpan="2" align="center"><b>Zoho</b></td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Automatic actions")}</td>
                <td width="*" valign="center">
                    {Translate("What actions should be automatically performed?")}<br/>
                    <br/>
                    <b className="smalltext">{Translate("Create calls in Zoho")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoCreateCall(evt.target.value)} value={settingautocreatecall}>
                        <option value="no">{Translate("Never")}</option>
                        <option value="yes">{Translate("Always")}</option>
                    </select><br/> 
                    <br/>
                    <b className="smalltext">{Translate("Open single-matching Zoho record")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoOpenMatch(evt.target.value)} value={settingautoopenmatch}>
                        <option value="">{Translate("Never")}</option>
                        <option value="started">{Translate("When you receive the call")}</option>
                        <option value="answered">{Translate("When you answer the call")}</option>
                    </select><br/> 
                    <br/>  
                    <b className="smalltext">{Translate("Create and show new Zoho contact when no matches are found")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoCreateMatch(evt.target.value)} value={settingautocreatematch}>
                        <option value="">{Translate("Never")}</option>
                        <option value="started">{Translate("When you receive the call")}</option>
                        <option value="answered">{Translate("When you answer the call")}</option>
                    </select><br/>       
                </td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Calls")}</td>
                <td width="*" valign="center">
                    {Translate("Default inbound call subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultinboundcallsubject} onChange={(evt) => SetDefaultInboundCallSubject(evt.target.value)}/><br/>
                    {Translate("Default outbound call subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultoutboundcallsubject} onChange={(evt) => SetDefaultOutboundCallSubject(evt.target.value)}/><br/>

                    <span className="smallesttext">{Translate("Available callfields") + ": <callid> <number> <name> <extension> <ddi> <ddiname> <callstart> <calltime> <talktime>"}</span><br/>                                       
                </td>
            </tr>
        </>
    )
}

export default EmbeddedZohoSettings